export default "__VITE_ASSET__B36Y$r_S__"